import { render, staticRenderFns } from "./OtpV2Component.vue?vue&type=template&id=7c53f973&scoped=true&"
import script from "./OtpV2Component.vue?vue&type=script&lang=js&"
export * from "./OtpV2Component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c53f973",
  null
  
)

export default component.exports